<template>
  <div class="no-policy-found">
    <BaseForm class="noprogress">
      <template v-slot:header>
        {{ policyTitle }}
      </template>
      <template v-if="policyCase">
        <div class="policy-case">
          <div class="policy-case__description">
            {{ policySubTitle }}
          </div>
          <div
            class="policy-case__success"
            v-if="isSuccededCase"
          >
            <p v-if="userPolicy"><span>{{ $t('renew_policy_number')}}:</span> <span>{{ userPolicy }}</span></p>
            <p><span>{{ $t('renew.common.insurance_period')}}:</span> <span>{{ policyDate }}</span></p>
          </div>
          <ul class="policy-case__list no-policy__list" v-if="policyCase === $options.POLICY_CASES.BY_EXTERNAL_LINK">
            <li v-if="userPolicy">
              <div class="no-policy__list-inner">
                <span>{{ $t('renew_policy_number') }}</span> <span>{{ userPolicy }}</span>
              </div>
            </li>
            <li v-if="userQid">
              <div class="no-policy__list-inner">
                <span>{{ $t('renew.common.qid_number') }}</span> <span>*******{{ userQid }}</span>
              </div>
            </li>
          </ul>
          <BaseButton
            v-if="policyCase === $options.POLICY_CASES.BY_EXTERNAL_LINK"
            class="policy-case__btn btn-second btn-second_medium"
            symbol="no"
            @click.prevent="goToMainPage"
          >
            {{ $t('renew.common.go_to_renewal_page')}}
          </BaseButton>

          <BaseButton
            v-if="showGoBackButton"
            class="policy-case__btn"
            symbol="no"
            @click="trackEvents('go_to_policy_managment')"
            @click.prevent="goToMainPage"
          >
            {{ $t('renew.common.go_back')}}
          </BaseButton>

          <a :href="payLink" target="_blank" @click="trackEvents('follow_the_link')" v-if="policyCase === $options.POLICY_CASES.PAYMENT_LINK">
            <BaseButton
              class="policy-case__btn"
              symbol="no"
            >
              {{ $t('renew.common.follow_the_link')}}
            </BaseButton>
          </a>

          <BaseButton
            v-if="showContactUsButton"
            class="policy-case__btn"
            :class="{'btn-second btn-second_medium': policyCase === $options.POLICY_CASES.PAYMENT_LINK}"
            symbol="no"
            @click="showNeedHelpPopup()"
          >
            {{ $t('renew.common.contact_us')}}
          </BaseButton>
        </div>
      </template>
      <div class="no-policy" v-else>
        <template v-if="onlyPolicyNumber">
          <div class="no-policy__desc" v-if="onlyPolicyNumber">{{$t('renew_policy_not_found1')}} <span dir="rtl"><strong>#{{ userPolicy }}</strong></span> {{$t('renew_policy_not_found2')}} </div>
        </template>
        <template v-else>
          <div class="no-policy__desc">{{ $t('renew_policies_not_found') }}</div>
          <ul class="no-policy__list">
            <li v-if="userPhone">
              <div class="no-policy__list-inner">
                <span>{{ $t('renew_mobile_number') }}</span> <span>{{ userPhone }}</span>
              </div>
            </li>
            <li v-if="userPolicy">
              <div class="no-policy__list-inner">
                <span>{{ $t('renew_policy_number') }}</span> <span>{{ userPolicy }}</span>
              </div>
            </li>
            <li v-if="userQid">
              <div class="no-policy__list-inner">
                <span>{{ $t('qic_user_qid_placeholder') }}</span> <span>*******{{ userQid }}</span>
              </div>
            </li>
          </ul>
        </template>
        <BaseButton class="btn mainBtn" v-if="!isAllUserData" symbol="no" @click.prevent="submit">
          {{ buttonText }}
        </BaseButton>

        <div class="no-policy__hotline">
          <div class="provideError">
            <div class="provideError__info">
              <div class="provideError__info-phone">
                <a href="tel:8000742" @click="trackEvents('click_callus')"><p>{{$t('qic_cant_provide_phone', { phone: hotlineNumber })}}</p></a>
                <a :href="whatsapUrl" @click="trackEvents('click_whatsapp')" target="_blank" class="btnWhatsapp"><i class="wa"></i> {{$t('qic_cant_provide_wa')}} </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseForm>
    <ContactUsPopup @click="trackEvents('contats_us')" v-model="needHelp" />
  </div>
</template>

<script>
import { BaseForm, ContactUsPopup } from 'qic-components'
import format from 'date-fns/format'
import { enGB as en, arSA as ar } from 'date-fns/locale'
import { POLICY_CASES } from '@/constants/policyConstants'
import { trackGtag } from '@/utils/useGtag'

export default {
  name: 'NoPolicyFound',
  data () {
    return {
      hotlineNumber: '8 000 742',
      needHelp: false
    }
  },
  props: ['policyCase', 'polEndDate', 'polStartDate', 'payLink'],
  components: {
    ContactUsPopup,
    BaseForm
  },
  POLICY_CASES,
  computed: {
    whatsapUrl () {
      return 'https://api.whatsapp.com/send/?phone=97451047909&amp;text&amp;app_absent=0'
    },
    userQid () {
      let qid = this.$store.state.renew.userData.qid
      if (qid) {
        qid = this.$store.state.renew.userData.qid.slice(-4)
      }
      return qid || this.$store.state.renew.userData.transId
    },
    userPhone () {
      return this.$store.state.renew.phoneNumberInfo.formattedPhone
    },
    userPolicy () {
      return this.$store.state.renew.userData?.policy || this.$store.state.renew.policyInfo?.policyNo
    },
    onlyPolicyNumber () {
      return this.userPolicy && !(this.userPhone && this.userQid)
    },
    formatLocale () {
      if (this.locale === 'ar') {
        return ar
      } else {
        return en
      }
    },
    locale () {
      return this.$i18n.locale
    },
    formattedStartDate () {
      return this.formatDate(this.$route.params.polStartDate)
    },

    formattedEndDate () {
      return this.formatDate(this.$route.params.polEndDate)
    },

    policyDate () {
      return `${this.formattedStartDate} - ${this.formattedEndDate}`
    },
    buttonText () {
      return this.onlyPolicyNumber ? this.$t('renew.common.go_back') : this.$t('renew_policy_not_found_enter_policy')
    },
    isAllUserData () {
      return this.userPolicy && this.userPhone && this.userQid
    },
    policyTitle () {
      const titleKeysByPolicyCase = {
        [POLICY_CASES.WILL_BE_ACTIVE]: 'renew.error_page.headers.policy_will_be_active',
        [POLICY_CASES.ALREADY_RENEWED]: 'renew.error_page.headers.policy_already_renewed',
        [POLICY_CASES.IS_ACTIVE]: 'renew.error_page.headers.policy_is_active',
        [POLICY_CASES.NO_RENEWAL_ALLOWED]: 'renew.error_page.headers.no_policies_to_renew',
        [POLICY_CASES.UNPAID_INSTALLMENT]: 'renew.error_page.headers.unpaid_installment',
        [POLICY_CASES.PAYMENT_LINK]: 'renew.error_page.headers.payment_link',
        [POLICY_CASES.BY_EXTERNAL_LINK]: 'renew.error_page.headers.no_policy_by_phone_and_qid'
      }
      const titleKey = titleKeysByPolicyCase[this.policyCase] || 'renew_policy_not_found_header'
      return this.$t(titleKey)
    },
    policySubTitle () {
      const subtitleKeysByPolicyCase = {
        [POLICY_CASES.WILL_BE_ACTIVE]: 'renew.error_page.subtitles.policy_will_be_active',
        [POLICY_CASES.ALREADY_RENEWED]: 'renew.error_page.subtitles.policy_already_renewed',
        [POLICY_CASES.IS_ACTIVE]: 'renew.error_page.subtitles.policy_is_active',
        [POLICY_CASES.NO_RENEWAL_ALLOWED]: 'renew.error_page.subtitles.no_policies_to_renew',
        [POLICY_CASES.UNPAID_INSTALLMENT]: 'renew.error_page.subtitles.unpaid_installment',
        [POLICY_CASES.PAYMENT_LINK]: 'renew.error_page.subtitles.payment_link',
        [POLICY_CASES.BY_EXTERNAL_LINK]: 'renew.error_page.subtitles.no_policy_by_phone_and_qid'
      }
      const subtitleKey = subtitleKeysByPolicyCase[this.policyCase]
      return subtitleKey ? this.$t(subtitleKey) : ''
    },

    isSuccededCase () {
      return [POLICY_CASES.WILL_BE_ACTIVE, POLICY_CASES.ALREADY_RENEWED, POLICY_CASES.IS_ACTIVE]
        .includes(this.policyCase)
    },

    showGoBackButton () {
      return [
        POLICY_CASES.WILL_BE_ACTIVE,
        POLICY_CASES.ALREADY_RENEWED,
        POLICY_CASES.IS_ACTIVE,
        POLICY_CASES.NO_RENEWAL_ALLOWED
      ].includes(this.policyCase)
    },
    showContactUsButton () {
      return [POLICY_CASES.PAYMENT_LINK, POLICY_CASES.UNPAID_INSTALLMENT].includes(this.policyCase)
    }
  },
  methods: {
    showNeedHelpPopup () {
      this.needHelp = true
      this.trackEvents('contacts_us')
    },
    formatDate (dateParam) {
      const date = Number(dateParam)
      if (!date) return ''
      const marker = this.locale === 'ar' ? '\u200f' : ''
      const formatString = this.locale === 'ar' ? 'd MMMM yyyy' : 'd MMM yyyy'
      return format(date, `${marker}${formatString}`, { locale: this.formatLocale })
    },
    submit () {
      if (this.onlyPolicyNumber) {
        this.$router.replace({ name: 'Home' })
      } else {
        this.$router.replace({
          name: 'Home',
          query: { type: 'policy' }
        })
      }
    },
    goToGetInsurancePage () {
      this.$router.push({ name: 'NotFound' })
    },
    goToMainPage () {
      this.$router.push({ name: 'Home' })

      if (this.policyCase && !(this.policyCase === POLICY_CASES.BY_EXTERNAL_LINK)) {
        this.trackEvents('go_back')
      } else if (this.policyCase === POLICY_CASES.BY_EXTERNAL_LINK) {
        this.trackEvents('go_to_renewal_page')
      }
    },
    trackEvents (name) {
      trackGtag(name, {
        title: this.policyTitle,
        text: this.policyCase ? this.policySubTitle : this.$t('renew_policies_not_found'),
        policyID: this.userPolicy,
        qid: this.$store.state.renew.userData.qid,
        type: 'error_page'
      })
    }
  },
  mounted () {
    setTimeout(() => {
      trackGtag('error_page', {
        title: this.policyTitle,
        text: this.policyCase ? this.policySubTitle : this.$t('renew_policies_not_found'),
        policyID: this.userPolicy,
        quoteID: this.$store.state.renew.policySchemesInfo?.info?.quoteno || '',
        qid: this.$store.state.renew.userData.qid
      })
    }, 3000)
  }
}
</script>

<style lang="scss" scoped>
.policy-case{
  display: grid;
  gap: 16px;

  &__list {
    max-width: 343px;
    width: 100%;
    margin: 0 auto 8px;
  }

  &__description {
    color: #000;
    text-align: center;
    font-size: 18px;
    line-height: 28px;
  }
  &__btn {
    margin-top: 8px !important;
  }
  &__success {
    display: grid;
    gap: 8px;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 12px;
    background: #DAFFCE;
    text-align: center;
    max-width: 416px;
    width: 100%;
    margin: 0 auto;

    p {
      color: rgba(82, 108, 130, 0.80);
      font-size: 14px;
      line-height: 24px;
      span {
        font-weight: 700;
      }
    }
  }
}
</style>
